module.exports = __webpack_public_path__ + "static/img/beijing-bg.cae7431.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/2020/app/beijing-bg.png
// module id = WvXy
// module chunks = 69